function getPageTitle(pageName: string): string {
    if (pageName) {
        return `${decodeURIComponent(pageName)} | Alan AI Studio`;
    }
    return `Alan AI Studio`;
}

export default getPageTitle;
